export default __webpack_public_path__ + "static/media/help2.84b8acee.svg";